module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "player",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "player"
    },
    on: {
      "mousemove": function($event) {
        _vm.showControlPanel(true)
      },
      "mouseout": function($event) {
        _vm.showControlPanel(false)
      }
    }
  }, [(_vm.video.state === 'stop') ? _c('img', {
    style: ({
      'position': 'absolute',
      'z-index': 1000,
      'top': '50%',
      'left': '50%',
      'width': _vm.playerHeight + 'px',
      'height': _vm.playerHeight + 'px',
      'margin-top': (_vm.playerHeight / -2) + 'px',
      'margin-left': (_vm.playerHeight / -2) + 'px',
      'cursor': 'pointer'
    }),
    attrs: {
      "src": require("../../assets/images/btn_video_play_L.png")
    },
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('video', {
    ref: "video",
    attrs: {
      "oncontextmenu": "return false;",
      "src": _vm.video.url
    },
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.panel.display && _vm.video.state === 'playing'),
      expression: "!panel.display && video.state === 'playing'"
    }],
    staticClass: "player-control p-0"
  }, [_c('progress-bar', {
    attrs: {
      "position": _vm.video.currentPos
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.display || _vm.video.state === 'stop'),
      expression: "panel.display || video.state === 'stop'"
    }],
    ref: "playerControl",
    staticClass: "player-control pt-2"
  }, [_c('progress-bar', {
    attrs: {
      "position": _vm.video.currentPos
    },
    on: {
      "seekTo": _vm.seekTo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-start pt-2 pb-2"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.backToBegin()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward fa-2x"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video.state !== 'playing'),
      expression: "video.state !== 'playing'"
    }],
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.play()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play fa-2x",
    attrs: {
      "aria-label": "play"
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video.state === 'playing'),
      expression: "video.state === 'playing'"
    }],
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pause fa-2x",
    attrs: {
      "aria-label": "pause"
    }
  })]), _vm._v(" "), (_vm.hasSubtitles) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    class: {
      'svg-red': _vm.repeat && _vm.repeatIdx >= 0
    },
    on: {
      "click": function($event) {
        _vm.repeatSingle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-redo-alt fa-2x",
    attrs: {
      "aria-label": "repeat"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasSubtitles) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.preSubtitle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-left fa-2x",
    attrs: {
      "aria-label": "left"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasSubtitles) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.nextSubtitle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right fa-2x",
    attrs: {
      "aria-label": "right"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('span', {
    staticClass: "btn",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.duration(_vm.video.currentTime)) + " | " + _vm._s(_vm.duration(_vm.video.duration)))]), _vm._v(" "), (_vm.hasSubtitles) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.switchSub('en')
      }
    }
  }, [(_vm.language === 'En') ? [(_vm.subs.en) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_video_en_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_video_en_off.png")
    }
  })] : _vm._e(), _vm._v(" "), (_vm.language === 'Ja') ? [(_vm.subs.en) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_video_jp_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_video_jp_off.png")
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.hasSubtitles) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.switchSub('tw')
      }
    }
  }, [(_vm.subs.tw) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_video_ch_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_video_ch_off.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isSupportFullscreen) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.fullscreen()
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFullscreen),
      expression: "!isFullscreen"
    }]
  }, [_c('i', {
    staticClass: "fa fa-2x fa-expand",
    attrs: {
      "aria-label": "exit fullscreen"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFullscreen),
      expression: "isFullscreen"
    }]
  }, [_c('i', {
    staticClass: "fa fa-2x fa-compress",
    attrs: {
      "aria-label": "exit fullscreen"
    }
  })])]) : _vm._e()])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6281a6ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/Player.vue
// module id = 732
// module chunks = 1